<template>
   <v-col  class="col-md-6 col-6">
    <v-card>
      <v-card-title primary-title>
        <v-row>
          <v-col cols="8" md="8">
            <img src='../../assets/bi-building.png' v-if="icon=='bi-building'"/>
            <img src='../../assets/bi-shop.png' v-if="icon=='bi-shop'"/>
            <img src='../../assets/bi-house-door.png' v-if="icon=='bi-house-door'"/>
            <a :href="url" target="_blank" v-if="url!=''">{{ title }}</a>
            <span v-else>{{ title }}</span>
          </v-col>
          <v-col cols="4" md="4" class="text-right">
            <edit :GroupName="title" :Icon="icon" :GroupDetail="detail" :GroupURL="url" :id="id" @complete="updateData"></edit>
            <v-btn icon color="red" class="btn-card">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <nl2br tag="p" :text="detail" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import Nl2br from 'vue-nl2br'
import Edit from './edit'
export default {
  components: {
      Edit,
      Nl2br
    },
  name: "Card",
  props: {
    title: String,
    icon: String,
    detail: String,
    url: String,
    id: Number
  },
  data() {
    return {};
  },
  methods: {
    updateData(){
      this.$emit('complete');
    },
  },
};
</script>
<style type="text/css">

.btn-card.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #ff000000 !important;
    color: #fff;
}
</style>